module.exports = __webpack_public_path__ + "static/img/fr1198x430_2.ecd5bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fr1198x430_2.png
// module id = eJFo
// module chunks = 6